<div class="container container-fixed">
  <div class="row">
    <div class="col-sm-12">
        @switch (currentPage) {
          @case ('Upload') {
            <app-developer-import-upload (goCompare)="compare($event)">
            </app-developer-import-upload>
          }
          @case ('Compare') {
            <app-developer-import-confirm [compareStatus]="compareStatus"
            (goCancel)="cancelImport()" (goImport)="import()" [versionMismatchDetected]="versionMismatchDetected"></app-developer-import-confirm>
          }
          @case ('Status') {
            <app-developer-import-status (goRestart)="restartImport()"></app-developer-import-status>
          }
        }
    </div>
  </div>
</div>
